import RoomIcon from '@mui/icons-material/Room';
import { useState } from 'react';

import { MapModalComponent } from '@/erp/tecnico/orden-trabajo/shared/components';
import { ColorTypeButton } from '@/shared';
import { SingleIconButton } from '../../ui';
import { Naps } from '@/shared/interfaces/erp/mantenimiento-operaciones';

export type IconBtnModalMapComponentProps = {
  coords: string;
  napsData?: Naps[];

  btnColor?: ColorTypeButton;
  btnLabel?: string;

  showCustomMap?: boolean;
  customMap?: React.ReactNode;
};

const IconBtnModalMapComponent: React.FC<IconBtnModalMapComponentProps> = ({
  coords,
  napsData,
  btnColor = 'primary',
  btnLabel = 'Ver mapa',

  showCustomMap = false,
  customMap = null,
}) => {
  const [isOpenModal, setIsOpenModal] = useState(false);

  return (
    <>
      {/* ============= btn ============= */}
      <SingleIconButton
        startIcon={<RoomIcon />}
        color={btnColor as any}
        label={btnLabel}
        onClick={() => {
          setIsOpenModal(true);
        }}
      />

      {/* ============= map ============= */}
      <MapModalComponent
        title="Ubicación del Cliente"
        coords={coords}
        napsData={napsData || []}
        open={isOpenModal}
        onClose={() => {
          setIsOpenModal(false);
        }}
        contentNodeOverride={showCustomMap ? customMap : null}
      />
    </>
  );
};

export default IconBtnModalMapComponent;
